import * as React from 'react'

import { itemDecorator } from '../../../../../common/utils/item'
import { getConfigBySite } from '../../../../../config/sites'
import createSearchResultBodyContainer, {
  Props
} from '../../../../shared/containers/searchResultBodyContainer'
import ItemsListing from '../../../components/itemsListing'

class SearchResultBody extends React.Component<Props> {
  public render() {
    const {
      matches,
      createFavoriteCollection,
      currentSite,
      collections,
      cartItems,
      token,
      deleteBookmark,
      addBookmark,
      favoriteCollectionID,
      openModal,
      location
    } = this.props

    const decorator = itemDecorator(
      currentSite,
      openModal,
      !token,
      favoriteCollectionID,
      collections,
      deleteBookmark,
      addBookmark,
      createFavoriteCollection,
      this.itemRankOffset(),
      cartItems,
      location
    )
    return (
      <ItemsListing
        items={matches}
        itemDecorator={decorator}
        location={location}
        currentSite={currentSite}
      />
    )
  }

  private itemRankOffset() {
    const { currentSite, location } = this.props

    const pageSize = getConfigBySite(currentSite, 'common.search_page_size')

    return ((Number(location.query.page) || 1) - 1) * pageSize + 1
  }
}

export default createSearchResultBodyContainer(SearchResultBody)
